import React from "react"
import { HeroContactType } from "../../types/heroTypes"
import { API } from "../../constants/constants"
import BaseRichtext from "../common/BaseRichtext"
import BaseHeadline from "../common/BaseHeadline"

export default function HeroContact(props: HeroContactType) {
    return (
        <div className="max-w-content mx-auto py-16">
            <img
                src={API + props.heroContactImage?.url}
                alt={props.heroContactImage?.description ?? props.heroContactImage?.name ?? "HeroContactImageAltTag"}
                className="w-4/5 ml-auto rounded-default aspect-[6/4] object-cover "
            />
            <div className="-mt-52 w-1/2 flex flex-col items-center relative z-10">
                <div className="bg-base-200 rounded-default py-8 px-12 w-full">
                    <BaseHeadline headlineType={1} label={props.heroContactHeading} />
                    <BaseRichtext content={props.heroContactText} classProps="pb-4" />
                </div>
                <div className="w-0 h-0 border-t-[50px] border-t-transparent border-b-[50px] border-b-transparent border-l-[30px] border-base-200 rotate-90 -mt-6" />
            </div>
        </div>
    )
}
